import React from 'react';
import { Router } from 'react-router-dom';



class PasswordReset extends React.Component {

  constructor(props) {
    super(props);
  }

  render() {

    return  <div className="App h-100">
              <div className="container-fluid h-100">
                <div className="row h-100">

                  

                  <div className="col-md-12 px-3 py-3 pb-md-4 text-left Tree">
                      <h1>PasswordReset</h1>
                    
                  </div>  
                </div>
              </div>
            </div>
  }

}


export default PasswordReset;
